module.exports = __webpack_public_path__ + "static/media/credit-cards.25e891b5.png";